@if (open) {
<div class="home-info-modal" role="dialog" aria-modal="true" aria-labelledby="home-info-title"
  (click)="onBackdrop($event)">
  <div class="home-info-modal__panel" (click)="$event.stopPropagation()">
    <header class="home-info-modal__header">
      <span class="home-info-modal__header-spacer" aria-hidden="true"></span>
      <h2 class="home-info-modal__title" id="home-info-title">
        {{ titulo }}
      </h2>
      <button type="button" class="home-info-modal__close" aria-label="Cerrar"
        [disabled]="finalizando" (click)="onClose()">
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <div class="home-info-modal__body">
      <p class="home-info-modal__text">{{ mensaje }}</p>

      @if (linkHref && linkLabel) {
      <a class="home-info-modal__link" [href]="linkHref" target="_blank" rel="noopener noreferrer">
        {{ linkLabel }}
      </a>
      }

      <div class="home-info-modal__actions">
        <button type="button" class="home-info-modal__btn home-info-modal__btn--secondary"
          id="btn-home-info-salir" [disabled]="finalizando" (click)="onClose()">
          {{ copy.ctaSalir }}
        </button>
        <button type="button" class="home-info-modal__btn home-info-modal__btn--primary"
          id="btn-home-info-finalizar" [disabled]="finalizando" (click)="onFinalizar()">
          {{ finalizando ? copy.ctaFinalizando : copy.ctaFinalizar }}
        </button>
      </div>
    </div>
  </div>
</div>
}
